import { t } from '@lingui/macro';
import { useLocale } from 'hooks/useLocale';

type PhoneNumberType = {
  phoneNumber: string;
  phoneNumberLink: string;
};
export const usePhoneNumber = (
  companyName?: string | null,
): PhoneNumberType => {
  const { isDE } = useLocale();

  if (companyName === 'Commerzbank' && isDE) {
    const phoneNumber = '069 / 1200 1282';
    const phoneNumberLink = `+49${phoneNumber
      .substring(phoneNumber.indexOf('0') + 1)
      .replace(/\s/g, '')
      .replace(/\//g, '')}`;

    return {
      phoneNumber,
      phoneNumberLink,
    };
  }

  const phoneNumber = t`020 3434 3481`;

  const phoneNumberLink = `${t`+44`}${phoneNumber
    .substring(1)
    .replace(/\s/g, '')}`;

  return {
    phoneNumber,
    phoneNumberLink,
  };
};
